export class NavBarItem
{
  topTitle : string;
  title: string;
  routerLink: string;
  iconName: string;
  importIcon : string;
  subMenus: NavBarItem[];

  constructor(topTitle : string, title: string, routerLink: string, iconName: string, importIcon:string = null, subMenus: NavBarItem[])
  {
    this.topTitle = topTitle;
    this.title = title;
    this.routerLink = routerLink;
    this.iconName = iconName;
    this.importIcon = importIcon;
    this.subMenus = subMenus;
    
  }
}